import { assertTimeZoneCheckResponseDto } from "@/utils/validation/generated/time-zone-check-response-dto.validator";
import { TimeZoneCheckDetailDto, TimeZoneCheckResponseDto } from "../dto/time-zone-check-dto";
import {
  TimeZoneCheckDetailInfo,
  TimeZoneCheckResponseInfo,
} from "../info/time-zone-check-reponse-info";

export class TimeZoneCheckReponseInfoMapper {
  static toEntity(dto: TimeZoneCheckResponseDto): TimeZoneCheckResponseInfo {
    assertTimeZoneCheckResponseDto(dto);

    const timezoneList: TimeZoneCheckDetailInfo[] = dto.timezone.map(
      (timezone: TimeZoneCheckDetailDto) => ({
        country_code: timezone.country_code,
        country_name: timezone.country_name,
        region_name: timezone.region_name,
        time_zone: timezone.time_zone,
      })
    );

    const result: TimeZoneCheckResponseInfo = {
      timezone: timezoneList,
      ip: dto.ip,
    };

    return result;
  }
}
